export const RELEASE_CADENCES = ['weekly', 'monthly', 'quarterly'] as const
export type ReleaseCadence = typeof RELEASE_CADENCES[number]

export const RELEASE_WEEKDAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
] as const

export type ReleaseWeekday = typeof RELEASE_WEEKDAYS[number]
export type ReleaseOccurrence = 1 | 2 | 3 | 4 | 'last'

type WeeklyReleaseSchedule = {
  cadence: 'weekly'
  weekday: ReleaseWeekday
  interval: number
  effectiveFrom: string
}

type MonthlyOrQuarterlyReleaseSchedule = {
  cadence: 'monthly' | 'quarterly'
  weekday: ReleaseWeekday
  occurrence: ReleaseOccurrence
  interval: number
  effectiveFrom: string
}

export type ProdReleaseSchedule = WeeklyReleaseSchedule | MonthlyOrQuarterlyReleaseSchedule

// Example: 3rd Tuesday monthly.
export const PROD_RELEASE_SCHEDULE: ProdReleaseSchedule = {
  cadence: 'monthly',
  weekday: 'tuesday',
  occurrence: 3,
  interval: 1,
  effectiveFrom: '2026-01-01',
}
